import {ComponentProps} from '@episerver/spa-core/EpiComponent';
import BulletsBlockData from 'app/Models/Content/BulletsBlockData';
import Property from '@episerver/spa-core/Components/Property';

import React from 'react';

const BulletsBlock = ({data, context}: ComponentProps<BulletsBlockData>) => (
  <div className='BulletsBlock'>
    <Property iContent={data} field='bullets' context={context} />
  </div>
);

export default BulletsBlock;
